<template>
  <div>
    <div v-show="isEditing">
      <div class="title">
        <i class="iconfont icon-back" @click="goback()"></i>
        <img src="/static/logo.png" />
        <div>"卖"队友</div>
      </div>
      <div class="weui-cells weui-cells_form" style="margin-top: 0px">
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px">昵称：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.nickname"
              maxlength="10"
              placeholder="被卖队友昵称"
            />
          </div>
        </div>
        <a
          class="weui-cell weui-cell_access"
          href="javascript:;"
          @click="showSexPicker"
        >
          <div class="weui-cell__bd">
            <label class="weui-label" style="width: 54px">性别：</label>
          </div>
          <div class="weui-cell__ft">
            {{ currSex.text ? currSex.text : "请选择" }}
          </div>
        </a>
        <div class="weui-cell">
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px">微信：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="circle.wxNo"
              maxlength="20"
              placeholder="请输入微信号"
            />
          </div>
        </div>
        <div class="weui-cell">
          <div class="weui-cell__bd">
            <textarea
              class="weui-textarea"
              v-model="circle.motto"
              maxlength="100"
              placeholder="座右铭"
              rows="2"
            ></textarea>
            <div
              class="weui-textarea-counter"
              :class="{
                'text-error': circle.motto && circle.motto.length > 100,
              }"
            >
              <span>{{ circle.motto ? circle.motto.length : 0 }}</span
              >/100
            </div>
          </div>
        </div>
        <div class="weui-cell cell-with-bnt">
          <div class="weui-cell__hd">
            <label class="weui-label" style="width: 54px">标签：</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              v-model="flag"
              maxlength="8"
              placeholder="如高富帅、白富美、户外达人等"
            />
          </div>
          <div class="weui-cell__ft" @click="addFlag">
            <button class="weui-vcode-btn">添加</button>
          </div>
        </div>
        <div class="weui-cell flag-container" v-if="circle.flags.length > 0">
          <div class="flags">
            <div
              class="flag"
              v-for="(item, index) in circle.flags"
              :key="index"
              @click="delFlag(item)"
            >
              <span>{{ item }}</span>
              <span class="flag-del">
                <i class="iconfont icon-chahao"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="weui-cell" id="headerUploader">
          <div class="weui-cell__bd">
            <div class="weui-uploader">
              <div class="weui-uploader__hd">
                <p class="weui-uploader__title">
                  请上传头像
                  <span style="color: red; font-size: 12px"
                    >（大小不能超过4M）</span
                  >
                </p>
                <div class="weui-uploader__info">
                  <span>{{ headerUploadCount }}</span
                  >/1
                </div>
              </div>
              <div class="weui-uploader__bd">
                <ul class="weui-uploader__files" id="headerUploaderFiles"></ul>
                <div class="weui-uploader__input-box">
                  <input
                    id="headerUploaderInput"
                    class="weui-uploader__input"
                    type="file"
                    accept="image/*"
                    multiple
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-cell" id="liveUploader">
          <div class="weui-cell__bd">
            <div class="weui-uploader">
              <div class="weui-uploader__hd">
                <p class="weui-uploader__title">
                  请上传生活照
                  <span style="color: red; font-size: 12px"
                    >（单张不能超过4M）</span
                  >
                </p>
                <div class="weui-uploader__info">
                  <span>{{ liveUploadCount }}</span
                  >/9
                </div>
              </div>
              <div class="weui-uploader__bd">
                <ul class="weui-uploader__files" id="liveUploaderFiles"></ul>
                <div class="weui-uploader__input-box">
                  <input
                    id="liveUploaderInput"
                    class="weui-uploader__input"
                    type="file"
                    accept="image/*"
                    multiple
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="warehousing-footer-item" style="flex: 1" @click="save">
        <a href="javascript:;">提 交</a>
      </div>
    </div>
    <div v-show="!isEditing">
      <div class="page">
        <div class="weui-msg">
          <div class="weui-msg__icon-area">
            <i class="weui-icon-success weui-icon_msg"></i>
          </div>
          <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">成功"卖"出</h2>
            <p class="weui-msg__desc">
              您可以点击微信右上角直接分享到朋友圈让更多人来"关照"TA哦ヾ(≧O≦)〃嗷~
            </p>
          </div>
          <div class="weui-msg__opr-area">
            <p class="weui-btn-area">
              <a
                href="javascript:;"
                class="weui-btn weui-btn_primary"
                @click="mai"
                >继续"卖"队友</a
              >
              <a
                href="javascript:;"
                class="weui-btn weui-btn_blue"
                @click="index"
                >到首页查看</a
              >
            </p>
          </div>
          <div class="weui-msg__extra-area">
            <div class="weui-footer">
              <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link"
                  >校圆通</a
                >
              </p>
              <p class="weui-footer__text">
                Copyright &copy; 2017-{{ year }} aixyt.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";
import moment from "moment";

export default {
  data() {
    return {
      encodeToken: null,
      token: null,
      isEditing: true,
      circle: {
        sex: -1,
        flags: [],
        pics: [],
      },
      sexPicker: null,
      sexs: [
        { text: "请选择", value: -1 },
        { text: "男", value: 1 },
        { text: "女", value: 0 },
      ],
      currSex: {},
      flag: null,
      headerUploadCount: 0,
      headerUploadList: [],
      liveUploadCount: 0,
      liveUploadList: [],
      token: "",
      year: moment().format("YYYY"),
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },
    mai() {
      this.$router.go(0);
    },
    index() {
      this.$router.push("/circleDiscovery/" + this.encodeToken);
    },
    showSexPicker() {
      if (!this.majorPicker) {
        this.majorPicker = this.$createPicker({
          title: "性别选择",
          data: [this.sexs],
          selectedIndex: [0],
          onSelect: this.selectSexHandle,
        });
      }
      this.majorPicker.show();
    },
    selectSexHandle(selectedVal, selectedIndex, selectedText) {
      this.currSex = this.sexs[selectedIndex];
      this.circle.sex = this.currSex.value;
    },
    addFlag() {
      if (this.flag) {
        let exist = false;
        for (let i = 0; i < this.circle.flags.length; i++) {
          if (this.flag == this.circle.flags[i]) {
            exist = true;
            break;
          }
        }
        if (!exist) {
          this.circle.flags.push(this.flag);
          this.flag = null;
        } else {
          weui.alert("该标签已存在");
          return;
        }
      }
    },
    delFlag(flag) {
      for (let i = 0; i < this.circle.flags.length; i++) {
        if (this.circle.flags[i] == flag) {
          this.circle.flags.splice(i, 1);
          break;
        }
      }
    },
    save() {
      if (!this.circle.nickname) {
        weui.alert("TA的昵称不能为空");
        return;
      } else if (this.circle.sex == -1) {
        weui.alert("请选择TA的性别");
        return;
      } else if (!this.circle.wxNo) {
        weui.alert("请输入TA的微信号");
        return;
      } else if (!this.circle.motto || this.circle.motto.length < 2) {
        weui.alert("TA的座右铭长度不能小于2");
        return;
      } else if (this.circle.flags.length < 2) {
        weui.alert("至少输入2个印象标签");
        return;
      } else if (!this.circle.header) {
        weui.alert("请上传TA的头像");
        return;
      } else if (this.circle.pics.length == 0) {
        weui.alert("至少上传一张生活照");
        return;
      } else {
        axios
          .post("/api/circle/sfadd", this.circle)
          .then((res) => {
            if (res.data.success) {
              this.isEditing = false;
            } else {
              weui.alert("提交失败");
            }
          })
          .catch((err) => {
            weui.alert("提交失败");
          });
      }
    },
  },
  mounted() {
    let that = this;
    /* 头像自动上传 */
    weui.uploader("#headerUploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "fileVal",
      compress: {
        width: 1600,
        height: 1600,
        quality: 0.8,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传正确格式的图片（jpg/png/gif）");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 1) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传1张图片");
          return false;
        }
        if (that.headerUploadCount + 1 > 1) {
          weui.alert("最多只能上传1张图片");
          return false;
        }

        that.headerUploadCount++;
      },
      onQueued: function () {
        that.headerUploadList.push(this);
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
      },
      onProgress: function (procent) {},
      onSuccess: function (ret) {
        that.circle.header = `${config.xytPreUrl}/sign/${ret.data.dateFolder}/${ret.data.destFileName}`;
      },
      onError: function (err) {
        console.log(err);
      },
    });

    // 图片点击
    document
      .querySelector("#headerUploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              that.headerUploadCount--;
              (function () {
                for (
                  var i = 0, len = that.headerUploadList.length;
                  i < len;
                  ++i
                ) {
                  var file = that.headerUploadList[i];
                  if (id && file._id && file._id == id) {
                    if (file.id) {
                      file.stop();
                    }
                    that.headerUploadList.splice(i, 1);

                    // 删除header数据
                    that.circle.header = null;
                  }
                }
              })();
              target.remove();
              gallery.hide();
            });
          },
        });
      });

    /* 生活照自动上传 */
    weui.uploader("#liveUploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "fileVal",
      compress: {
        width: 1600,
        height: 1600,
        quality: 0.8,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传正确格式的图片（jpg/png/gif）");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 9) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传9张图片");
          return false;
        }
        if (that.liveUploadCount + 1 > 9) {
          weui.alert("最多只能上传9张图片");
          return false;
        }

        that.liveUploadCount++;
      },
      onQueued: function () {
        that.liveUploadList.push(this);
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
      },
      onProgress: function (procent) {},
      onSuccess: function (ret) {
        let picUrl = `${config.xytPreUrl}/sign/${ret.data.dateFolder}/${ret.data.destFileName}`;
        that.circle.pics.push(picUrl);
      },
      onError: function (err) {
        console.log(err);
      },
    });

    // 图片点击
    document
      .querySelector("#liveUploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              that.liveUploadCount--;
              (function () {
                for (
                  var i = 0, len = that.liveUploadList.length;
                  i < len;
                  ++i
                ) {
                  var file = that.liveUploadList[i];
                  if (id && file._id && file._id == id) {
                    if (file.id) {
                      file.stop();
                    }
                    that.liveUploadList.splice(i, 1);

                    // 删除pics数据
                    for (let j = 0; j < that.circle.pics.length; j++) {
                      if (file.url == that.circle.pics[j].blobUrl) {
                        that.circle.pics.splice(j, 1);
                        return;
                      }
                    }
                  }
                }
              })();
              target.remove();
              gallery.hide();
            });
          },
        });
      });
  },
};
</script>

<style scoped>
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
.weui-btn_blue {
  background-color: #1296db;
}
.title {
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  border-bottom: 1px solid #1296db;
  position: relative;
}
.title i {
  position: absolute;
  left: 10px;
  font-size: 22px;
  color: #1296db;
}
.title img {
  width: 18px;
  height: 18px;
  padding: 2px;
  border-radius: 50%;
  border: 2px solid #1296db;
}
.title div {
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
  color: #6b6e77;
}
.text-error {
  color: red;
}
.flag-container {
  width: 100%;
  margin-right: 10px;
}
.flags {
  display: inline-block;
  margin-right: 30px;
}
.flag {
  background-color: #296aed;
  color: #ffffff;
  font-size: 14px;
  padding: 2px 10px;
  border-radius: 13px;
  display: inline-block;
  margin-top: 4px;
  margin-right: 10px;
}
.flag-del {
  margin-left: 5px;
}
.cell-with-bnt {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-right: 0px;
}
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #296aed;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/operations/CircleSfEdit.vue